<template>
  <div style="width: 100%; height: 100%" ref="mychart"></div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'StackedColumn',
  props: {
    title: {
      type: String,
      default: ''
    },
    xData: {
      type: Array,
      required: true
    },
    yData: {
      type: Array,
      required: true
    }
  },
  watch: {
    yData() {
      this.initMyChart() // 重置图表
    },
    deep: true,
    xData() {
      this.initMyChart() // 重置图表
    }
  },
  mounted() {
    // this.initMyChart()
    setTimeout(() => {
      this.initMyChart()
      const resizeOb = new ResizeObserver((entries) => {
        for (const entry of entries) {
          echarts.getInstanceByDom(entry.target).resize()
        }
      })
      resizeOb.observe(this.$refs.mychart)
    })
  },
  methods: {
    initMyChart() {
      let mychart = echarts.getInstanceByDom(this.$refs.mychart)
      if (mychart == null) mychart = echarts.init(this.$refs.mychart)
      const yAxisData = this.yData
      const xAxisData = this.xData

      const option = {
        title: {
          text: this.title,
          left: 'center',
          top: 15,
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          //data: 每一项代表一个系列的name，如果没有指定会从当前系列中自动获取
          top: '10%',
          // type: 'scroll'
          textStyle: {
            color: '#aaa',
            fontSize: 12
          }
        },
        color: ['#667eea', '#19be6b', '#ff9a9e', '#fbc2eb'],
        grid: {
          left: '2%',
          right: '5%',
          bottom: '3%',
          top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            // type: 'category',
            // data: xAxisData,
            type: 'value' //度量轴数据，需series配置
          }
        ],
        yAxis: [
          {
            type: 'category', //维度
            data: yAxisData,
            axisLable: {
              // show: true,
              // width: 30,
              // rotate: 30,
              // interval: 0
              // textBorderColor: '#f9f9'
            }
          }
        ],
        series: xAxisData
        // series: [
        //   // xAxisData,
        //   {
        //     type: 'bar' //柱状
        //     //     // 数据配置
        //     //     barMaxwidth: '20%',
        //     // data: xAxisData
        //     //     // stack: 'Ad',
        //     //     // name: this.topText
        //     //     // yAxisIndex: 2
        //   }
        // ]
      }
      mychart.setOption(option, true)
    }
  }
}
</script>
